export default __webpack_public_path__ + "static/media/InsideBlood_00.dfe9ff7c.png";